import { render, staticRenderFns } from "./PopupAboutTask.vue?vue&type=template&id=adf8c6c2&scoped=true&"
import script from "./PopupAboutTask.vue?vue&type=script&lang=js&"
export * from "./PopupAboutTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf8c6c2",
  null
  
)

export default component.exports